<template>
  <div
    class="rate-item"
    :class="[{ selected: isSelected }]"
  >
    <div class="rate-title">
      <span class="title">{{ rate.title || 'Our best rate' }}</span>
      <div class="rate-view-more">
        <a
          tabindex="0"
          @keydown.enter.prevent="$emit('select', rate)"
          @click.prevent="$emit('select', rate)"
          @keydown.space.prevent="$emit('select', rate)"
        >
          {{ tc('booking.seeDetails') }}
        </a>
      </div>
    </div>
    <div class="rate-description">
      <div class="rate-info">
        <div class="description">
          {{ rateDescription }}
        </div>
        <div class="rate-view-more">
          <a
            tabindex="0"
            @keydown.enter.prevent="$emit('select', rate)"
            @click.prevent="$emit('select', rate)"
            @keydown.space.prevent="$emit('select', rate)"
          >
            {{ tc('booking.seeDetails') }}
          </a>
        </div>
      </div>
      <div class="rate-cta-wrapper">
        <div class="rate-price">
          <div class="price">
            <span>{{ ratePrice }}</span>
            <span
              class="price-label"
            >{{ tc('booking.perNight') }}</span>
          </div>
        </div>
        <div
          class="rate-cta"
          :class="[{ 'is-selecting': isLoading }]"
        >
          <button
            :disabled="isDisabled"
            :class="[{ loading: isLoading }]"
            @click="doCartAction"
            @keydown.space.prevent="doCartAction"
          >
            <span v-if="!isLoading">
              {{ !isSelected ? tc('booking.bookThisRate') : tc('booking.keepThisRate') }}
            </span>
            <loading-dots v-else />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RateCardMixin from '@mixins/rate-card-mixin'
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'RateItem',
    mixins: [RateCardMixin],
    computed: {
      ...mapState('responsive', { wWidth: 'width' }),
      ...mapGetters('booking', ['showPricesWithTaxes']),
      rateDescription() {
        const tmp = document.createElement('DIV')
        const lenght = this.isMobile ? 40 : 80
        tmp.innerHTML = this.rate.shortDescription || this.rate.longDescription
        const text = tmp.textContent || tmp.innerText || ''
        return text.length > lenght ? `${text.substring(0, lenght)}...` : text
      },
      isMobile() {
        return this.wWidth <= 767
      },
      ratePrice() {
        return this.showPricesWithTaxes() ? this.avgPriceWithTaxes : this.avgPrice
      }
    }
  }
</script>
